import {
  ASSIGN_GROUP_GET_GROUP_LIST_INIT,
  ASSIGN_GROUP_GET_GROUP_LIST_SUCCESS,
  ASSIGN_GROUP_GET_GROUP_LIST_FAILURE,
  ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_INIT,
  ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_SUCCESS,
  ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_FAILURE,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_INIT,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_SUCCESS,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_FAILURE,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_INIT,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_SUCCESS,
  ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_FAILURE,
  ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_INIT,
  ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_SUCCESS,
  ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_FAILURE,
  ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_INIT,
  ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_SUCCESS,
  ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_FAILURE,
  ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_INIT,
  ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS,
  ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE,
  ASSIGN_GROUP_IMPORT_INIT,
  ASSIGN_GROUP_IMPORT_SUCCESS,
  ASSIGN_GROUP_IMPORT_FAILURE,
  ASSIGN_GROUP_IMPORT_RESET,
  ASSIGN_GROUP_GET_PERIODS_LIST_INIT,
  ASSIGN_GROUP_GET_PERIODS_LIST_SUCCESS,
  ASSIGN_GROUP_GET_PERIODS_LIST_FAILURE,
  ASSIGN_GROUP_SET_PERIOD_ID,
  ASSIGN_GROUP_RESET,
  ASSIGN_GROUP_SOFT_RESET
} from './types';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';

export function resetAssignGroupAdmin() {
  return {
    type: ASSIGN_GROUP_RESET
  };
}

export function softResetAssignGroupAdmin() {
  return {
    type: ASSIGN_GROUP_SOFT_RESET
  };
}

export function getGroupList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_GET_GROUP_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_GET_GROUP_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_GET_GROUP_LIST_FAILURE, error));
    }  
  };
}

export function getCalculationUnitList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_GET_CALCULATION_UNIT_LIST_FAILURE, error));
    }  
  };
}

export function getGroupCalculationUnitsList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/getcalculationunits",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_GET_GROUP_CALCULATION_UNITS_LIST_FAILURE, error));
    }  
  };
}

export function getCalculationUnitGroupsList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/getgroups",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_GET_CALCULATION_UNIT_GROUPS_LIST_FAILURE, error));
    }  
  };
}

export function saveGroupCalculationUnit(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_INIT,
      params: data
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        data.add == true ? "/api/group/addcalculationunit" : "/api/group/removecalculationunit",
        data.add == true ? "PUT" : "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_SAVE_GROUP_CALCULATION_UNIT_FAILURE, error));
    }  
  };
}

export function saveCalculationUnitGroup(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_INIT,
      params: data
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        data.add == true ? "/api/calculationunit/addgroup" : "/api/calculationunit/removegroup",
        data.add == true ? "PUT" : "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_SAVE_CALCULATION_UNIT_GROUP_FAILURE, error));
    }  
  };
}

export function downloadImportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/downloadgroupsassignsimportfile",
        "GET",
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE, error));
    }  
  };
}

export function importAssigns(files, params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(ASSIGN_GROUP_IMPORT_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/calculationunit/importgroupassigns",
        files,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_IMPORT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_IMPORT_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: ASSIGN_GROUP_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(ASSIGN_GROUP_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(ASSIGN_GROUP_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function setPeriodId(id) {
  return {
    type: ASSIGN_GROUP_SET_PERIOD_ID,
    id: id
  };
}

export function resetImport() {
  return {
    type: ASSIGN_GROUP_IMPORT_RESET
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/assignGroupAdmin/index.js